import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { ShipmentPlannerProfileListService } from './shipment-planner-profile-list.service';
import {
  ShipmentPlannerProfileListInitialState,
  ShipmentPlannerProfileListLoad,
} from './shipment-planner-profile-list.actions';
import { LIST_SERVER_PAGINATION_INITIAL_STATE, ListServerPaginationStateModel } from '../../../../../common/models';
import { NotificationService } from '../../../../../common/services/notification/notification.service';
import { PlannerProfile } from '../../../../models';
import { Error, CustomHttpErrorResponse } from '../../../../../common';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export type ShipmentPlannerProfileListStateModel = ListServerPaginationStateModel<PlannerProfile>;

const initialState: ShipmentPlannerProfileListStateModel = LIST_SERVER_PAGINATION_INITIAL_STATE;

@State<ShipmentPlannerProfileListStateModel>({
  name: 'shipmentPlannerProfileList',
  defaults: initialState,
})
@Injectable()
export class ShipmentPlannerProfileListState {
  constructor(
    private materialPlannerProfileListService: ShipmentPlannerProfileListService,
    private notificationService: NotificationService,
  ) {}

  @Selector()
  static getState(state: ShipmentPlannerProfileListStateModel): ShipmentPlannerProfileListStateModel {
    return state;
  }
  @Selector()
  static getItems(state: ShipmentPlannerProfileListStateModel): PlannerProfile[] {
    return state.items;
  }
  @Selector()
  static getLoaded(state: ShipmentPlannerProfileListStateModel): boolean {
    return state.loaded;
  }

  @Action(ShipmentPlannerProfileListLoad)
  getShipmentList(
    ctx: StateContext<ShipmentPlannerProfileListStateModel>,
    { payload }: ShipmentPlannerProfileListLoad,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.materialPlannerProfileListService.getShipmentPlannerProfileList(payload).pipe(
      map((materialPlannerProfileList: ShipmentPlannerProfileListStateModel) => {
        ctx.patchState({ ...materialPlannerProfileList, loaded: true });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(ShipmentPlannerProfileListInitialState)
  setInitialState(ctx: StateContext<ShipmentPlannerProfileListInitialState>): void {
    ctx.setState(initialState);
  }
}
